function InfoHero() {
    return (
        <div className="info-hero">
            <h2 className="info-headline">Sustainability 101.</h2>
            <p className="info-text"> With so much information out there, it's hard to get it in smaller, digestible chucks. Below are some key points about why sustainability is so important and how you can take small steps to help the environment.</p>
        </div>
    )
}

export default InfoHero